import React from "react";
import { mmToPx } from "../utils/labelSizes";
import ElementRenderer from "./ElementRenderer";

// Read-only render of a full label (used for preview, thumbnails, print, PDF source).
const LabelCanvas = ({
  widthMm,
  heightMm,
  backgroundColor = "#ffffff",
  backgroundImageUrl = "",
  backgroundImageOpacity = 0.35,
  borderColor = "#d0d7de",
  borderWidth = 0,
  elements = [],
  dataMap,
  scale = 1,
}) => {
  const widthPx = mmToPx(widthMm) * scale;
  const heightPx = mmToPx(heightMm) * scale;

  return (
    <div
      style={{
        position: "relative",
        width: widthPx,
        height: heightPx,
        backgroundColor: backgroundColor || "#ffffff",
        border: borderWidth ? `${borderWidth}px solid ${borderColor}` : "none",
        boxSizing: "border-box",
        overflow: "hidden",
        boxShadow: "0 0 0 1px #ddd",
      }}
    >
      {backgroundImageUrl ? (
        <img
          alt=""
          aria-hidden="true"
          src={backgroundImageUrl}
          crossOrigin="anonymous"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: backgroundImageOpacity,
            pointerEvents: "none",
            userSelect: "none",
          }}
        />
      ) : null}
      {[...elements]
        .filter((el) => !el.hidden)
        .sort((a, b) => (a.zIndex || 0) - (b.zIndex || 0))
        .map((el) => (
          <div
            key={el.id}
            style={{
              position: "absolute",
              zIndex: (el.zIndex || 0) + 1,
              left: mmToPx(el.x) * scale,
              top: mmToPx(el.y) * scale,
              width: mmToPx(el.width) * scale,
              height: mmToPx(el.height) * scale,
              transform: `rotate(${el.rotation || 0}deg)`,
              transformOrigin: "center center",
            }}
          >
            <ElementRenderer element={el} dataMap={dataMap} />
          </div>
        ))}
    </div>
  );
};

export default LabelCanvas;
